/**
 * O nome de quem hospeda, lido da página.
 *
 * O sistema é uma doação, e quem receber põe o nome dele sem recompilar o painel. O servidor
 * preenche a `<meta name="nome-do-sistema">` ao subir, a partir da variável `NOME_DO_SISTEMA`.
 * Ver `src/painel/pagina.ts`, do lado do servidor.
 *
 * Lido uma vez, quando o painel abre: é um valor que não muda enquanto a aba estiver aberta.
 */

/** O buraco que o servidor preenche. Vê-lo na tela significa que a página não passou por ele. */
const BURACO = '__NOME_DO_SISTEMA__'

function lerDaPagina(): string {
  const meta = document.querySelector('meta[name="nome-do-sistema"]')
  const valor = meta?.getAttribute('content')?.trim()
  /*
   * Vazio ou com o buraco ainda dentro acontece no servidor de desenvolvimento do Vite, que
   * entrega o `index.html` sem passar pelo nosso servidor. Melhor uma frase sem graça do que
   * `__NOME_DO_SISTEMA__` escrito no alto da tela de entrar.
   */
  if (!valor || valor === BURACO) return 'Painel'
  return valor
}

export const NOME_DO_SISTEMA = lerDaPagina()
